import { render, staticRenderFns } from "./Plan.vue?vue&type=template&id=11f58912&lang=pug&"
import script from "./Plan.vue?vue&type=script&lang=ts&"
export * from "./Plan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports